import { validate } from "../Validation/validator";

export const wishlistHelpers = {
    hideDropdowns() {
        const dropdowns = document.querySelectorAll("[data-js-wishlist-list-actions]");
        if (!dropdowns) {
            return;
        }
        dropdowns.forEach((dropdown) => {
            dropdown.classList.remove("opened");
        });
    },

    validateElements(parentElement) {
        this.valid = false;
        let validateElements = parentElement.querySelectorAll("[data-validate]");
        for (let i = 0; i < validateElements.length; i++) {
            let element = validateElements[i];
            this.valid = this.validateElement(element, parentElement);
            if (!this.valid) {
                return;
            }
        }
    },

    validateElement(element, parentElement) {
        let valid = false;
        let rules = JSON.parse(element.getAttribute("data-validate"));
        let validateMessages = JSON.parse(element.getAttribute("data-validate-messages"));
        valid = validate(
            "string",
            {
                field: element,
                rules: rules,
                validateMessages: validateMessages,
            },
            parentElement
        );

        return valid;
    },
};
